import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BiData } from '@wix/da-bi/pkg/events';
import { useBiLogger } from '@wix/da-bi/pkg/hooks/useBiLogger';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import BooleanInput from '@wix/da-ds/pkg/formControls/dsPresets/BooleanInput';
import { PremiumTrash } from '@wix/da-ds/pkg/Icons/Confirmations';
import { deviationTypeToTranslationKey, getDeviationResourceType, getDeviationType } from '../../../../DeviationViews/_helpers';
import ConfirmationModal from '../../../../Popup/ConfirmationModal';
import RadioButton from '@wix/da-ds/pkg/RadioButton';
import s from './DeleteConfirmationModal.scss';
const DeleteConfirmationModal = (_param)=>{
    var { deviation, onConfirm } = _param, rest = _object_without_properties(_param, [
        "deviation",
        "onConfirm"
    ]);
    var _deviation_adoptable, _deviation_adoptable1, _deviation_author;
    const { t } = useTranslation();
    const isUnpublishFlagEnabled = useFlag('unpublish');
    const [adoptableConfirmActionValue, setAdoptableConfirmActionValue] = useState('unpublish');
    const logBiEvent = useBiLogger();
    var _ref;
    const isAdopted = (_ref = deviation.isAdoptable && ((_deviation_adoptable = deviation.adoptable) === null || _deviation_adoptable === void 0 ? void 0 : _deviation_adoptable.owner) && ((_deviation_adoptable1 = deviation.adoptable) === null || _deviation_adoptable1 === void 0 ? void 0 : _deviation_adoptable1.owner.username) !== ((_deviation_author = deviation.author) === null || _deviation_author === void 0 ? void 0 : _deviation_author.username)) !== null && _ref !== void 0 ? _ref : false;
    const shouldUnpublishInstead = isUnpublishFlagEnabled && isAdopted && !!deviation.isPublished && adoptableConfirmActionValue === 'unpublish';
    const isConfirmable = isAdopted && !isUnpublishFlagEnabled;
    const [isConfirmChecked, setIsConfirmChecked] = useState(true);
    const toggleIsConfirmChecked = useCallback(()=>{
        setIsConfirmChecked(!isConfirmChecked);
    }, [
        isConfirmChecked
    ]);
    const type = getDeviationType(deviation);
    const typeName = t(deviationTypeToTranslationKey(type));
    const handleConfirmation = useCallback(()=>{
        logBiEvent(BiData({
            evid: 376,
            itemid: deviation.deviationId,
            typeid: getDeviationResourceType(deviation)
        }));
        onConfirm && onConfirm(shouldUnpublishInstead);
    }, [
        logBiEvent,
        onConfirm,
        deviation,
        shouldUnpublishInstead
    ]);
    return /*#__PURE__*/ React.createElement(ConfirmationModal, _object_spread({
        title: t('actionbar.delete.confirm', {
            type: typeName
        }),
        text: isAdopted && deviation.isPublished ? isUnpublishFlagEnabled ? /*#__PURE__*/ React.createElement("div", {
            className: s['with-adoptable-options']
        }, /*#__PURE__*/ React.createElement("p", null, t('actionbar.delete.withAdoptableUnpublishOption.description')), /*#__PURE__*/ React.createElement(RadioButton, {
            name: "adoptable-action",
            size: "small",
            checked: adoptableConfirmActionValue === 'unpublish',
            id: "delete-confirm",
            value: "unpublish",
            className: s['radio-button'],
            onChange: ()=>setAdoptableConfirmActionValue('unpublish')
        }, t('actionbar.delete.withAdoptableUnpublishOption.unpublish', {
            postProcess: [
                'reactPostprocessor'
            ],
            learnMoreLink: /*#__PURE__*/ React.createElement("a", {
                className: "text-link-level-2-secondary",
                href: t('actionbar.delete.withAdoptableUnpublishOption.learnMoreLink.url')
            }, t('actionbar.delete.withAdoptableUnpublishOption.learnMoreLink.text'))
        })), /*#__PURE__*/ React.createElement(RadioButton, {
            name: "adoptable-action",
            size: "small",
            id: "delete-confirm",
            checked: adoptableConfirmActionValue === 'delete',
            value: "delete",
            className: s['radio-button'],
            onChange: ()=>setAdoptableConfirmActionValue('delete')
        }, t('actionbar.delete.withAdoptableUnpublishOption.deleteConsent'))) : /*#__PURE__*/ React.createElement("div", null, t('actionbar.delete.cantGoBack.adopted'), /*#__PURE__*/ React.createElement(BooleanInput, {
            type: "checkbox",
            size: "small",
            id: "delete-confirm",
            value: isConfirmChecked,
            className: s['checkbox'],
            label: t('actionbar.delete.cantGoBack.adopterConsent'),
            labelClassName: s['checkbox-label'],
            onChange: toggleIsConfirmChecked
        })) : t('actionbar.delete.cantGoBack'),
        confirmBtnLabel: shouldUnpublishInstead ? t('actionbar.unpublish') : t('actionbar.delete'),
        cancelBtnLabel: t('popup.cancel'),
        variant: isAdopted && isUnpublishFlagEnabled ? 'horizontal' : undefined,
        icon: !(isAdopted && isUnpublishFlagEnabled) && /*#__PURE__*/ React.createElement(PremiumTrash, null),
        confirmBtnType: shouldUnpublishInstead ? 'default' : 'danger',
        confirmBtnDisabled: isConfirmable && !isConfirmChecked,
        onConfirm: handleConfirmation
    }, rest));
};
DeleteConfirmationModal.displayName = 'DeleteConfirmationModal';
export default DeleteConfirmationModal;

//# sourceMappingURL=DeleteConfirmationModal.js.map